import * as React from 'react'
import * as Container from "../../container/container";

const Video = (key) => {
    return (
        <Container.Part background="beige" id="trailer" key={key}>
            <Container.Row>
                <div className="col-12">
                    <div className="inner-container">
                        <h2>Landtagspräsidentin Ilse Aigner führt durchs Maximilianeum.</h2>
                        <figure className="video">
                            <div className="yt-container yt-enabled">
                                <Container.Video
                                    url={"/videos/Filmmaterial/000_Maximilianeum/211011_Maxmimilianeum.mp4"}
                                    poster={"/images/Videowallpaper/maximilianeum.jpg"}/>
                            </div>
                        </figure>
                    </div>
                </div>
            </Container.Row>
        </Container.Part>
    )
}

export default Video
